
import * as XLSX from 'xlsx';
import { adminCreateUser } from '../auth/adminAuthService';

/**
 * Parses an Excel file and returns an array of user objects.
 * Expects columns: Ad Soyad, E-posta, Rol, Telefon, Şifre
 * 
 * @param {File} file - The Excel file from input
 * @returns {Promise<Array>} List of user objects
 */
export const parseUsersExcel = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = XLSX.utils.sheet_to_json(worksheet);

                // Map Excel headers to system fields
                const mappedUsers = json.map(row => ({
                    fullName: row['Ad Soyad'] || row['Full Name'],
                    email: row['E-posta'] || row['Email'],
                    role: row['Rol'] || row['Role'],
                    phone: row['Telefon'] || row['Phone'],
                    password: String(row['Şifre'] || row['Password'] || '123456') // Default password if empty
                })).filter(u => u.email && u.fullName);

                resolve(mappedUsers);
            } catch (error) {
                reject(new Error('Excel dosyası okunamadı: ' + error.message));
            }
        };
        reader.onerror = () => reject(new Error('Dosya okuma hatası'));
        reader.readAsArrayBuffer(file);
    });
};

/**
 * Processes the bulk creation of users.
 * 
 * @param {Array} users - List of user objects
 * @param {String} tenantId - Current admin's tenantId
 * @param {Function} onProgress - Callback for progress updates (current, total)
 * @returns {Promise<Object>} Results with success and error counts
 */
export const bulkCreateUsers = async (users, tenantId, onProgress) => {
    const results = {
        success: [],
        errors: []
    };

    for (let i = 0; i < users.length; i++) {
        const userData = users[i];
        try {
            const created = await adminCreateUser({
                ...userData,
                tenantId
            });
            results.success.push(created);
        } catch (error) {
            results.errors.push({
                email: userData.email,
                error: error.message
            });
        }

        if (onProgress) {
            onProgress(i + 1, users.length);
        }
    }

    return results;
};

/**
 * Generates and downloads a sample Excel template for user upload.
 */
export const downloadUserTemplate = () => {
    const data = [
        {
            'Ad Soyad': 'Örnek Kullanıcı',
            'E-posta': 'ornek@sirket.com',
            'Rol': 'dock_staff',
            'Telefon': '05550000000',
            'Şifre': '123456'
        }
    ];

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Kullanıcılar');

    // Generate buffer
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Trigger download
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'kullanici_yukleme_sablonu.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
};
